import { useState } from "react";
import PageHeader from "../-components/PageHeader";
import Seo from "components/Seo";
import DriverScheduleForm, { DriverScheduleFormState } from "./DriverScheduleForm";

export default function ConsoleDriverScheduleCreate() {
    const [form, setForm] = useState<DriverScheduleFormState>({
        schedule_no: null,
        schedule_nos: [],
        warehouse_no: "",
        driver_no: "",
        work_date: "",
        work_start_date: "",
        work_end_date: "",
    });

    return (
        <>
            <Seo type="console" pageTitle="일자별 입고지 기사 관리" />
            <div className="flex-1 flex flex-col overflow-hidden max-h-[100dvh]">
                <PageHeader category="고객서비스" title="일자별 기사배정 등록" />
                <div className="flex-1 bg-[#F7F6FB] flex overflow-hidden">
                    <div className="px-[40px] py-[28px] w-full overflow-auto">
                        <div className="bg-white rounded-[20px] py-[36px] px-[40px] min-w-[800px]">
                            <DriverScheduleForm form={form} setForm={setForm} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
